import { PropTypes } from 'react-desc';

var props = {
  /** Injected props to wrapper element of component */
  containerProps: PropTypes.object.description('Injected props to wrapper element of component'),

  /**
   * Whether uses auto focus or not
   */
  autoFocus: PropTypes.bool.description('Whether uses auto focus or not'),

  /** CSS class */
  className: PropTypes.string.description('CSS class'),

  /**
   * Whether is disabled or not
   */
  disabled: PropTypes.bool.description('Whether is disabled or not'),

  /** HTML form name property */
  name: PropTypes.string.description('HTML form name property'),

  /** HTML id */
  id: PropTypes.number.description('HTML id'),

  /**
   * Max length for text to be entered
   */
  maxLength: PropTypes.number.description('Max length for text to be entered'),

  /**
   * Min length for text to be entered
   */
  minLength: PropTypes.number.description('Min length for text to be entered'),

  /**
   * Placeholder for the text
   */
  placeholder: PropTypes.string.description('Placeholder for the text'),

  /**
   * Allows a function that is triggered once the input text is clicked
   */
  onClick: PropTypes.func.description('Allows a function that is triggered once the input text is clicked'),

  /**
   * Allows a function that is triggered once the input text changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the input text changes'),

  /**
   * Allows a function that is triggered once the input text is focused
   */
  onFocus: PropTypes.func.description('Allows a function that is triggered once the input text is focused'),

  /**
   * Allows a function that is triggered once the input text loses focus
   */
  onBlur: PropTypes.func.description('Allows a function that is triggered once the input text loses focus'),

  /**
   * Allows a function that is triggered once in the input a keyboard key is released
   */
  onKeyUp: PropTypes.func.description('Allows a function that is triggered once in the input a keyboard key is released'),

  /**
   * Allows a function that is triggered once a key is being pressed
   */
  onKeyDown: PropTypes.func.description('Allows a function that is triggered once a key is being pressed'),

  /**
   * Allows a function that is triggered once the input text is pasted
   */
  onPaste: PropTypes.func.description('Allows a function that is triggered once the input text is pasted'),

  /**
   * Default value once the component is initialized
   */
  value: PropTypes.string.description('Default value once the component is initialized'),

  /**
   * Whether the input text has error or not
   */
  hasError: PropTypes.bool.description('Whether the input text has error or not'),

  /**
   * Whether the input text is required or not
   */
  required: PropTypes.bool.description('Whether the input text is required or not'),

  /**
   * Whether the input text is read only or not
   */
  readOnly: PropTypes.bool.description('Whether the input text is read only or not'),

  /**
   * Whether the input text style is vertical or not
   */
  resize: PropTypes.string.description('Whether the input text style is vertical or not'),

  /** ref forwarded to component */
  innerRef: PropTypes.func.description('ref forwarded to component'),

  /** a11y aria label */
  ariaLabel: PropTypes.string.description('a11y aria label'),
  ariaAutocomplete: PropTypes.string.description(''),

  /**
   * Type of input. Ex: textbox
   */
  role: PropTypes.string.description('Type of input. Ex: textbox'),

  /**
   * it will show a counter/limit if the value is greater than 0
   */
  characterLimitCounter: PropTypes.number.description('it will show a counter/limit if the value is greater than 0'),

  /**
   * Tab index html property.
   */
  tabIndex: PropTypes.string.description('Tab index html property.')
};

export { props };
//# sourceMappingURL=props.js.map
